'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uiComponents = require('@wh/ui-components');

require('./modal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = (0, _jsx3.default)('i', {
    className: 'sb-modal-component__close-icon'
});

/**
 * Modal component
 * @returns {Element} React element
 */
var Modal = function (_Component) {
    (0, _inherits3.default)(Modal, _Component);

    function Modal() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Modal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.closeModalOnUserRequest = function () {
            var _this$props = _this.props,
                closeModal = _this$props.closeModal,
                _this$props$onClose = _this$props.onClose,
                onClose = _this$props$onClose === undefined ? function () {} : _this$props$onClose;


            closeModal();
            onClose();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Modal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                t = _props.t,
                _props$name = _props.name,
                name = _props$name === undefined ? '' : _props$name,
                _props$activeModalNam = _props.activeModalName,
                activeModalName = _props$activeModalNam === undefined ? '' : _props$activeModalNam,
                _props$children = _props.children,
                children = _props$children === undefined ? null : _props$children,
                _props$contentLabel = _props.contentLabel,
                contentLabel = _props$contentLabel === undefined ? '' : _props$contentLabel,
                _props$closeOnOverlay = _props.closeOnOverlayClick,
                closeOnOverlayClick = _props$closeOnOverlay === undefined ? true : _props$closeOnOverlay,
                _props$modalClassName = _props.modalClassName,
                modalClassName = _props$modalClassName === undefined ? '' : _props$modalClassName,
                _props$overlayClassNa = _props.overlayClassName,
                overlayClassName = _props$overlayClassNa === undefined ? '' : _props$overlayClassNa;


            if (!name || name !== activeModalName) {
                return null;
            }

            var modalClassNames = (0, _classnames2.default)('sb-modal-component', modalClassName);
            var overlayClassNames = (0, _classnames2.default)('sb-modal-component__overlay', overlayClassName);

            return (0, _jsx3.default)(_reactModal2.default, {
                isOpen: true,
                portalClassName: 'sb',
                className: modalClassNames,
                overlayClassName: overlayClassNames,
                shouldCloseOnOverlayClick: closeOnOverlayClick,
                onRequestClose: this.closeModalOnUserRequest,
                contentLabel: contentLabel
            }, void 0, (0, _jsx3.default)(_uiComponents.NavItem, {
                type: 'button',
                style: 'bare',
                onClick: this.closeModalOnUserRequest,
                className: 'sb-modal-component__close'
            }, void 0, (0, _jsx3.default)('span', {}, void 0, t('modal')('close')), _ref2), (0, _jsx3.default)('div', {
                className: 'sb-modal-component__wrapper'
            }, void 0, children));
        }
    }]);
    return Modal;
}(_react.Component);

exports.default = Modal;
//# sourceMappingURL=modal.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/modal-component/dist/main/modal.js
// module id = 506
// module chunks = 0